
import { mapGetters } from 'vuex'

export default {
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      size: this.$route.query?.groesse,
      sort: this.$route.query?.sortierung || 'relevanz',
      sortOptions: [
        { label: 'Relevanz', value: 'relevanz' },
        { label: 'Teuerste', value: 'teuerste' },
        { label: 'Neuste', value: 'neueste' },
        { label: 'Älteste', value: 'aelteste' },
        { label: 'Günstigste', value: 'guenstigste' },
      ],

      showFilter: false,
    }
  },

  computed: {
    ...mapGetters('global', ['dimensionUnits']),
  },

  watch: {
    size(newSize) {
      this.$router.push({
        path: this.$route.path,
        query: { ...this.$route.query, groesse: newSize },
      })
    },

    sort(newSort) {
      this.$router.push({
        path: this.$route.path,
        query: { ...this.$route.query, sortierung: newSort },
      })
    },
  },

  mounted() {
    if (this.dimensionUnits.length === 0) {
      this.$store.dispatch('global/loadDimensionUnits')
    }
  },

  methods: {
    openFilter() {
      this.showFilter = true
    },

    updateFilter(tags) {
      this.size = tags
    },
  },
}
